import {Component, OnInit} from '@angular/core';
import { StorefrontComponent, PageTemplateDirective, OutletDirective, MockKeyboardFocusDirective, PageLayoutComponent, PageSlotComponent } from '@spartacus/storefront';
import { EfaGlobalMessageComponent } from '../efa-global-message/efa-global-message.component';
import { RouterOutlet } from '@angular/router';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-efa-storefront',
    templateUrl: './efa-storefront.component.html',
    styleUrls: ['./efa-storefront.component.scss'],
    imports: [PageTemplateDirective, OutletDirective, MockKeyboardFocusDirective, PageLayoutComponent, PageSlotComponent, EfaGlobalMessageComponent, RouterOutlet, AsyncPipe]
})
export class EfaStorefrontComponent extends StorefrontComponent implements OnInit {

  ngOnInit(): void {
    super.ngOnInit();
  }

}
